/**
 * 2019/1/25
 * 作者:lzq
 *功能: 日志分析模块
 */
export default {
  $getway: 'sysapi',
  getHierarchyNumProportion: 'portLog/getHierarchyNumProportion',
  getPoliceNumProportion: 'portLog/getPoliceNumProportion',
  getAnalyseTerminal: 'portLog/getAnalyseTerminal',
  getAnalyseConsumeTime: 'portLog/getAnalyseConsumeTime',
  getAnalyseTimeSegment: 'portLog/getAnalyseTimeSegment'
};
